"use client";

import { logSmoke } from "@/app/actions/smoke";
import { useTransition } from "react";

interface SmokeButtonProps {
    count: number;
}

export function SmokeButton({ count }: SmokeButtonProps) {
    const [isPending, startTransition] = useTransition();

    const handleSmoke = () => {
        startTransition(async () => {
            await logSmoke();
        });
    };

    return (
        <div className="flex flex-col items-center justify-center relative">
            {/* Glow Effect */}
            <div className="absolute inset-0 bg-[#3b82f6]/20 rounded-full blur-3xl animate-pulse"></div>

            <button
                onClick={handleSmoke}
                disabled={isPending}
                className="group relative w-72 h-72 rounded-full flex items-center justify-center transition-all duration-300 active:scale-95"
            >
                {/* Outer Ring */}
                <div className="absolute inset-0 rounded-full border border-[#334155] bg-[#0f172a]/80 backdrop-blur-md shadow-2xl"></div>

                {/* Inner Progress/Glow Ring */}
                <div className="absolute inset-2 rounded-full border-[6px] border-[#1e293b] shadow-[inset_0_0_20px_rgba(0,0,0,0.5)]"></div>

                {/* Active Ring */}
                <div className="absolute inset-2 rounded-full border-[2px] border-t-[#3b82f6] border-r-[#3b82f6]/50 border-b-transparent border-l-transparent animate-spin-slow opacity-80"></div>

                {/* Core Reactor */}
                <div className="absolute inset-8 rounded-full bg-gradient-to-br from-[#1e293b] to-black shadow-[inset_0_2px_10px_rgba(255,255,255,0.05)] border border-[#334155] flex flex-col items-center justify-center group-hover:border-[#3b82f6]/50 transition-colors">

                    {/* Core Light */}
                    <div className={`w-32 h-32 rounded-full bg-gradient-to-t ${isPending ? "from-[#064e3b] to-[#10b981]" : "from-[#1e3a8a] to-[#3b82f6]"} opacity-20 blur-xl absolute transition-colors duration-500`}></div>

                    <div className="relative z-10 text-center">
                        <div className="text-xs font-bold text-[#60a5fa] uppercase tracking-[0.2em] mb-2">{isPending ? "RECORDING" : "TAP TO LOG"}</div>
                        <div className={`text-4xl font-black text-white transition-opacity duration-300 ${isPending ? "opacity-50" : "opacity-100"}`}>
                            +1
                        </div>
                        <div className="text-[10px] text-[#64748b] mt-2 font-mono">SMOKE_EVENT</div>
                    </div>
                </div>
            </button>
        </div>
    );
}
